import * as tslib_1 from "tslib";
import { FieldType } from '@ngx-formly/core';
var FormlyFieldTypeChooserComponent = /** @class */ (function (_super) {
    tslib_1.__extends(FormlyFieldTypeChooserComponent, _super);
    function FormlyFieldTypeChooserComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return FormlyFieldTypeChooserComponent;
}(FieldType));
export { FormlyFieldTypeChooserComponent };
